module.exports = __webpack_public_path__ + "media/patternencryption.464e7844.mp4";